module.exports = __webpack_public_path__ + "img/appAsset-brand--dian.344d5467.svg";